import * as _ from "lodash";
import * as THREE from "three";
import {Node} from "../Node";
import {_toThreeComplex, _toThreeValuePromise, AbstractProperty} from "./AbstractProperty";
import {json} from "../../global";

export class PColor extends AbstractProperty<string, Node> {

    constructor(args) {
        super({
            type: 'Color',
            default: null,
            ...args
        });
    }

    typeCheck(value: string): boolean {
        return _.isString(value) && /^#(?:[0-9a-fA-F]{3}){1,2}$/.test(value);
    }

    toJSON(): json {
        return _.clone(this.get()) as any;
    }

    fromJSON(json: json): this {
        this.set(json[this.name]);
        return this;
    }

    toThree(instance: any) {
        _toThreeComplex(this, instance, "Color",
            (instance, value) => _toThreeValuePromise(new THREE.Color()),
            (instance, value, instanceValue, freshlyCreated) =>
                instanceValue.set(value));
    }

    threeToInternalFormat(value: THREE.Color): string {
        return value == null ? null : '#' + value.getHexString();
    }

}
